import * as React from "react";

import { Sidebar } from "@/components/ui/sidebar";

import { AppSidebarContent } from "./content";
import { AppSidebarFooter } from "./footer";
import { AppSidebarHeader } from "./header";

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  return (
    <Sidebar className="bg-background" variant="inset" {...props}>
      <AppSidebarHeader />
      <AppSidebarContent />
      <AppSidebarFooter />
    </Sidebar>
  );
}
